export const DonatelloTipsTranslation = {
    en: `
Callback setup

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatello/1.webp "Overlay Url")

The nickname can be found on the basic data settings page. It is used to redirect viewers to the Donatello page.

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatello/2.webp "Overlay Url")
    `,
    uk: `
Налаштування колбеку

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatello/1.webp "Overlay Url")

Нікнейм можна знайти на сторінці налаштувань основних даних. Він використовується для перенаправлення глядачів на сторінку Donatello.

![Overlay Url](${process.env.REACT_APP_CDN_BASE_URL}/payment-methods/donatello/2.webp "Overlay Url")
    `
}
